import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class HomeFeature extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'HomeFeature';

    // Define default properties here
    static instanceDefaults() {
        return {
            fHomeId: null,
            icon: null,
            name: null,
            order: null,
            featureId: null,
            feature: null,
        }
    }

    // static setupInstance(data, { models }) {
    //     if (data.HomeFeature) {
    //         data.HomeFeature = new models.api.HomeFeature(data.HomeFeature)
    //     }
    //     return data
    // }
}

const servicePath = 'f-home-features';
const servicePlugin = makeServicePlugin({
    Model: HomeFeature,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin